import { Checkbox } from "@/components/ui/checkbox";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { industries } from "@/data/industries";
import { useFormContext } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "../ui/input";

type WorkFieldProps = {
  isApplicationForm?: boolean;
};

const WorkFields = ({ isApplicationForm = false }: WorkFieldProps) => {
  const isEmployedKey = isApplicationForm
    ? "is_employed"
    : "member.is_employed";
  const employerKey = isApplicationForm ? "employer" : "member.employer";
  const industryKey = isApplicationForm ? "industry" : "member.industry";
  const positionKey = isApplicationForm ? "position" : "member.position";

  const { control, watch } = useFormContext();
  const isEmployed = watch(isEmployedKey);
  return (
    <div className="space-y-4 font-verona">
      <FormField
        control={control}
        name={isEmployedKey}
        render={({ field }) => (
          <FormItem className="flex items-center space-x-2">
            <FormControl>
              <Checkbox
                id="isEmployed"
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <FormLabel
              htmlFor="isEmployed"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 font-verona"
            >
              Are you currently employed?
            </FormLabel>
            <FormMessage />
          </FormItem>
        )}
      />

      {isEmployed && (
        <>
          <FormField
            control={control}
            name={employerKey}
            render={({ field }) => (
              <FormItem>
                <FormLabel htmlFor="employer">Current Employer *</FormLabel>
                <FormControl>
                  <Input
                    type="text"
                    id="employer"
                    placeholder="e.g., Google, Bapco, Ministry of Education"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={control}
            name={industryKey}
            render={({ field }) => (
              <FormItem>
                <FormLabel htmlFor="industry">Industry *</FormLabel>
                <FormControl>
                  <Select value={field.value} onValueChange={field.onChange}>
                    <SelectTrigger
                      id="industry"
                      className="w-full border-2 border-neutral-light bg-white text-gray-900 font-verona"
                    >
                      <SelectValue placeholder="Select an industry" />
                    </SelectTrigger>
                    <SelectContent className="bg-white border shadow-lg font-verona">
                      {industries.map((industry) => (
                        <SelectItem
                          key={industry}
                          value={industry}
                          className="focus:bg-[#233A74] focus:text-white hover:bg-[#233A74] hover:text-white transition-colors data-[highlighted]:bg-[#233A74] data-[highlighted]:text-white font-verona"
                        >
                          {industry}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={control}
            name={positionKey}
            render={({ field }) => (
              <FormItem>
                <FormLabel htmlFor="position">Current Position *</FormLabel>
                <FormControl>
                  <Input
                    type="text"
                    id="position"
                    placeholder="e.g., Software Engineer, Account Manager"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </>
      )}
    </div>
  );
};

export default WorkFields;
